// The default labels of the raw component names the reports use. `t` is the caller's $t.
export function defaultComponentDictionary (t) {
  return {
    base: t('components.simulationDetails.SalesDecomposition.base'),
    marketing_residual: t('components.simulationDetails.SalesDecomposition.carryOverMarketing'),
    marketing: t('components.simulationDetails.SalesDecomposition.instantMarketing'),
    Marketing: t('components.simulationDetails.SalesDecomposition.instantMarketing'),
    noise: t('components.simulationDetails.SalesDecomposition.noise'),
    seasonality: t('components.simulationDetails.SalesDecomposition.seasonality'),
    external: t('components.simulationDetails.SalesDecomposition.external')
  }
}

// The labels the Sales Decomposition shows for its components: the default labels of the raw
// names (base, marketing, noise, ...) merged with the model's custom component names. When a
// custom name is keyed by one of the default labels, that custom name wins for the raw name too.
// Shared by the Sales Decomposition chart and the Model Report's XLSX download so both name the
// components alike.
export function mergeComponentDictionary (defaultDictionary, customDictionary) {
  if (!customDictionary) {
    return defaultDictionary
  }
  // A COPY of the custom dictionary, never the object itself: it is written to just below, and
  // callers hand in the model's own pretty_names.components straight out of the Vuex store.
  // Writing the default component labels into it left the store's dictionary claiming that
  // 'base', 'marketing', 'noise'… are custom aliases for every consumer mounted after the chart —
  // which silently reordered the Sales Decomposition of the Model Report on any visit that
  // wasn't the first one (see salesDecompositionV2Data in ModelReportComponent).
  const dictionary = { ...customDictionary }
  const dictKeys = Object.keys(customDictionary)
  const dictValues = dictKeys.map(key => customDictionary[key])
  Object.entries(defaultDictionary).forEach(([key, value]) => {
    if (dictKeys.includes(value)) {
      dictionary[key] = dictValues[dictKeys.indexOf(value)]
    } else {
      dictionary[key] = value
    }
  })
  return dictionary
}
